import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    style={{ minWidth: 24 }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
    onClick={disabled ? null : onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9986 5.99645C17.8033 6.19171 17.4877 6.19042 17.2809 6.00747C15.87 4.75962 14.0253 4 11.995 4C7.575 4 4.005 7.58 4.005 12C4.005 16.42 7.575 20 11.995 20C15.4986 20 18.4552 17.7501 19.5388 14.6178C19.6456 14.3089 19.4065 14 19.0796 14H17.9991C17.7869 14 17.5998 14.1348 17.5175 14.3304C16.6113 16.4863 14.4799 18 11.995 18C8.685 18 5.995 15.31 5.995 12C5.995 8.69 8.685 6 11.995 6C13.4755 6 14.8129 6.54886 15.8509 7.44083C16.0597 7.62021 16.0577 7.9373 15.8631 8.13193L13.8486 10.1464C13.5336 10.4614 13.7567 11 14.2021 11H19.495C19.7711 11 19.995 10.7761 19.995 10.5V5.20711C19.995 4.76165 19.4564 4.53857 19.1415 4.85355L17.9986 5.99645Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
